import { useState } from 'react';
import cn from 'classnames';

import useClickOutside from '../../hooks/useClickOutside.js';
import useFocusOutside from '../../hooks/useFocusOutside.js';
import useMergeRefs from '../../hooks/useMergeRefs.js';
import MegaMenu from './MegaMenu.jsx';
import ExpandButton from './ExpandButton.jsx';
import SubMenu from './SubMenu.jsx';
import MenuItemBox from './MenuItemBox.jsx';
import LdsContactLilly from '../LdsContactLilly/index.jsx';
import LdsIcon from '../LdsIcon/index.jsx';
export default function InteractiveMenuItem({
  index,
  itemText,
  iconName = '',
  iconPosition = 'after',
  newTab,
  href,
  type,
  submenuItems = [],
  megaMenuItems = [],
  additionalLink,
  externalCallback,
  current,
  options,
  menuType,
  isMobile,
  closeMegaMenuLabel,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const clickOutsideRef = useClickOutside(() => {
    setIsOpen(false);
  });
  const focusOutsideRef = useFocusOutside(() => {
    setIsOpen(false);
  });
  const mergedRefs = useMergeRefs(clickOutsideRef, focusOutsideRef);
  function toggleOpen() {
    setIsOpen(!isOpen);
  }
  const liClassName = cn(
    'lds-header-menu-item',
    `lds-header-menu-item-type-${type}`,
    {
      'lds-header-menu-item-current': current,
      'lds-header-menu-item-has-submenu': submenuItems.length > 0,
      'lds-header-menu-item-has-mega-menu': megaMenuItems.length > 0,
      'lds-header-menu-item-dropdown-active lds-header-menu-item-submenu-active lds-header-menu-item-mega-menu-active':
        isOpen,
      'lds-header-menu-item-submenu-not-active': !isOpen,
    }
  );

  if (type === 'contact-lilly') {
    return (
      <li ref={mergedRefs} tabIndex="-1" className={liClassName}>
        <div className="lds-header-menu-item-content toggleHeaderMenu">
          <LdsContactLilly options={options} />
          <div className="lds-header-menu-item-toggle will-rotate">
            <div className="lds-header-menu-item-icon-mega-menu-mobile">
              <LdsIcon inline name="CaretRight" />
            </div>
            <div className="lds-header-menu-item-icon-default">
              <LdsIcon inline name="CaretDown" />
            </div>
          </div>
        </div>
      </li>
    );
  }
  // id used for aria-controls
  function determineControlId() {
    if (megaMenuItems.length) {
      return `lds-header-menu-item-${menuType}-${index}`;
    }
    if (submenuItems.length) {
      return `lds-header-menu-submenu-${menuType}-${index}`;
    }
    return '';
  }
  const controlId = determineControlId();

  function renderExpandButtonOrMenuItemBox() {
    if (submenuItems.length || megaMenuItems.length) {
      return (
        <ExpandButton
          menuType={menuType}
          index={index}
          itemText={itemText}
          iconName={iconName}
          iconPosition={iconPosition}
          expanded={isOpen}
          controlId={controlId}
        />
      );
    }
    return (
      <MenuItemBox
        itemText={itemText}
        iconName={iconName}
        iconPosition={iconPosition}
        newTab={newTab}
        href={href}
        type={type}
        isOpen={isOpen}
        alwaysFocusable={true}
        externalCallback={externalCallback}
      />
    );
  }

  function renderMegaMenu() {
    if (megaMenuItems.length) {
      return (
        <MegaMenu
          index={index}
          megaMenuItems={megaMenuItems}
          additionalLink={additionalLink}
          itemText={itemText}
          iconName={iconName}
          iconPosition={iconPosition}
          active={isOpen}
          toggleOpen={toggleOpen}
          menuType={menuType}
          isMobile={isMobile}
          closeMegaMenuLabel={closeMegaMenuLabel}
          controlId={controlId}
        />
      );
    }
    return null;
  }

  function renderSubMenu() {
    if (submenuItems.length) {
      return (
        <SubMenu
          submenuItems={submenuItems}
          isOpen={isOpen}
          controlId={controlId}
        />
      );
    }
    return null;
  }

  return (
    <li ref={mergedRefs} tabIndex="-1" className={liClassName}>
      <div
        className="lds-header-menu-item-content toggleHeaderMenu"
        onClick={toggleOpen}
      >
        {renderExpandButtonOrMenuItemBox()}
      </div>
      {renderMegaMenu()}
      {renderSubMenu()}
    </li>
  );
}
